import React, { useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const DonatChart = ({ data, title, subtitle, centerLabel, onSliceClick,verticalWiseChart }) => {
  const chartRef = useRef(null);
  const options = {
    chart: {
      type: 'pie',
      events: {
        render: function () {
          const chart = this;
          const series = chart.series[0];

          let customLabel = chart.customLabel;
          if (!customLabel) {
            customLabel = chart.customLabel = chart.renderer
              .label(centerLabel, 0, 0, 'center')
              .css({
                color: '#000',
                textAlign: 'center'
              })
              .attr({ align: 'center' })
              .add();
          }

          const x = series.center[0] + chart.plotLeft;
          const y = series.center[1] + chart.plotTop - customLabel.getBBox().height / 2;

          customLabel.attr({ x, y });
          customLabel.css({ fontSize: `${series.center[2] / 12}px` });
        }
      }
    },
    title: { text: title || '' },
    subtitle: {
      useHTML: true,
      text: subtitle || ''
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>'
    },
    plotOptions: {
      pie: {
        innerSize: '75%',
        allowPointSelect: true,
        cursor: 'pointer',
        borderRadius: 8,
        dataLabels: [
          {
            enabled: true,
            distance: 20,
            format: '{point.name}'
          },
          {
            enabled: true,
            distance: -15,
            format: '{point.percentage:.0f}%',
            style: { fontSize: '0.9em' }
          }
        ],
        showInLegend: false,
        point: {
          events: {
            click: function () {
              if (onSliceClick) {
                onSliceClick(this); // Pass the clicked point data
              }
            }
          }
        }
      }
    },
    series: [
      {
        name: 'Data',
        colorByPoint: true,
        data: data || []
      }
    ],
    credits: { enabled: false },
    legend: { enabled: false },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    }
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      ref={chartRef}
      containerProps={{ style: { height: '300px', width: '100%' } }}
    />
  );
};


export default DonatChart;
